module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section section-white"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-position": "left",
      "label-width": "120px"
    }
  }, [_c('div', {
    staticClass: "section-body"
  }, [
    [_c('el-form-item', {
      attrs: {
        "label": "购物车顶部营销语:"
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "100px"
      },
      attrs: {
        "required": "",
        "placeholder": ""
      },
      model: {
        value: (_vm.form.ad_title),
        callback: function($$v) {
          _vm.$set(_vm.form, "ad_title", $$v)
        },
        expression: "form.ad_title"
      }
    })], 1)]
  ], 2), _vm._v(" "), _c('div', {
    staticClass: "section-footer with-border content-center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保 存")])], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-67e5c3fa", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67e5c3fa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/trade/cartadsetting.vue
// module id = 2791
// module chunks = 0